///
/// EarthBrowser
///
/// Migration v28 to v29: Remove dead toolDock / context panel state
/// Created by Matt Giger on September 6, 2026
/// Copyright (c) 2026 Geodata Labs
///

/**
 * Migration: v28 to v29
 *
 * Changes:
 * - Removes unused toolDock fields from userInterface state
 *   (toolsOpen, toolDockPosition, toolDockPaneSize, toolDockState, toolDockOpenToolId)
 * - Removes unused context panel fields (contextPanelOpen, contextPanelToolId)
 *
 * These fields were leftover from a removed tools panel and had no UI consumers.
 */
interface UserInterfaceV28 {
	toolsOpen?: unknown
	toolDockPosition?: unknown
	toolDockPaneSize?: unknown
	toolDockState?: unknown
	toolDockOpenToolId?: unknown
	contextPanelOpen?: unknown
	contextPanelToolId?: unknown
}

interface StateV28 {
	userInterface?: UserInterfaceV28
}

export function migrateV28toV29(state: unknown): unknown {
	const s = state as StateV28 | null | undefined
	if (!s?.userInterface) return state

	const userInterface = { ...s.userInterface }
	delete userInterface.toolsOpen
	delete userInterface.toolDockPosition
	delete userInterface.toolDockPaneSize
	delete userInterface.toolDockState
	delete userInterface.toolDockOpenToolId
	delete userInterface.contextPanelOpen
	delete userInterface.contextPanelToolId

	return {
		...s,
		userInterface,
	}
}
